/**
 * Created by qiangxl on 2018-09-02.
 */
/*参观服务-子路由*/
export default [
  {
    path: '/synopsis/jng_gk',
    name: 'jng_gk',
    component: resolve => require(['@/components/synopsis/jng_gk/index.vue'], resolve),
    meta: {
      title: '纪念馆概况'
    }
  },
  {
    path: '/synopsis/exhibition_zl',
    name: 'exhibition_zl',
    redirect: '/synopsis/exhibition_zl/list',
    component: resolve => require(['@/components/synopsis/exhibition_zl/index.vue'], resolve),
    meta: {
      title: '展览欣赏'
    },
    children: [
      {
        path: '/synopsis/exhibition_zl/list',
        name: 'zl_list',
        component: resolve => require(['@/components/synopsis/exhibition_zl/list.vue'], resolve),
        meta: {
          title: '最新展览'
        }
      },
      {
        path: '/synopsis/exhibition_zl/detail/:exhibition_id',
        name: 'zl_detail',
        component: resolve => require(['@/components/synopsis/exhibition_zl/detail.vue'], resolve),
        meta: {
          title: '展览详情'
        }
      }
    ]
  },
  {
    path: '/synopsis/visit_service',
    name: 'visit_service',
    component: resolve => require(['@/components/synopsis/visit_service/index.vue'], resolve),
    meta: {
      title: '参观服务'
    }
  },
  {
    path: '/synopsis/order_service',
    name: 'order_service',
    component: resolve => require(['@/components/synopsis/order_service.vue'], resolve),
    meta: {
      title: '预约服务'
    }
  },
  {
    path: '/synopsis/coming_soon',
    name: 'coming_soon',
    component: resolve => require(['@/components/synopsis/coming_soon.vue'], resolve),
    meta: {
      title: '敬请期待'
    }
  }
]


// WEBPACK FOOTER //
// ./src/router/synopsis/index.js